import React, { Component } from 'react';
import PageHeader from '../components/PageHeader';

class IndexComponent extends Component {

    render() {
        return (
            <div id="page-wrapper">
                <PageHeader title="Page is not ready"/>
                <h2>
                    <i className="fa fa-frown-o"></i>
                    This page is not ready yet.</h2>
            </div>
        );
    }
}

export default IndexComponent;



/** WEBPACK FOOTER **
 ** ./src/pages/Index.js
 **/